import styles from './ProgressBar.module.css';

interface ProgressBarProps {
    coverage?: { coverage: number, total: number };
    classname: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ coverage, classname }) => {
    const percentage = (coverage?.coverage! * 100) / coverage?.total!;
    return (
        <div className={`progress ${styles.progress_container} ${classname}`}>
            <div
                className={`progress-bar ${styles.progressbar}`}
                style={{ width: `${percentage}%` }}
            ></div>
        </div>
    )
}